<template>
  <div id="response">
    <top></top>
    <div class="main">
      <!-- 左侧菜单 -->
      <navMenu :active="active"></navMenu>
      <!-- 右侧内容区域 -->
      <div class="content">
        <div class="go-back" @click="goBack">
          {{ lang === "cn" ? "返回" : "Back" }}
        </div>
        <div class="content-main">
          <div class="main-title">
            {{ lang === "cn" ? "应答内容" : "Response Content" }}
          </div>
          <div v-if="responseList.length !== 0">
            <div
              class="main-collapse"
              v-for="(item, index) in responseList"
              :key="index"
            >
              <div
                class="main-collapse-header"
                @click="handleOpenCollapseItem(index, item.id)"
              >
                <div>
                  {{ item.name + " " + item.company + " " + item.duty }}
                </div>
                <i
                  :class="{
                    'el-icon-arrow-right': true,
                    'arrow-rotate': item.active,
                  }"
                ></i>
              </div>
              <div
                :class="{
                  'main-collapse-content': true,
                  active: item.active,
                }"
              >
                <div class="main-collapse-timing">{{ item.create_time }}</div>
                <div>{{ item.response_content }}</div>
                <div class="main-collapse-delete">
                  <img src="../assets/delete.jpg" alt="" />
                  <div @click="handleDeleteResponse(item.id)">
                    {{ lang === "cn" ? "删除" : "Delete" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="main-nodata">
            {{
              lang === "cn"
                ? "暂无应答内容"
                : "Currently no response content available."
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import {
  getBusinessOpportunityResponseList,
  getBusinessOpportunityResponseDetail,
  deleteBusinessOpportunityResponseDetail,
} from "../api/api";
export default {
  components: { top, navMenu },
  name: "response",
  data() {
    return {
      lang: "",
      active: "",
      opportunity_id: "",
      responseList: [],
      pageNumber: 1,
      pageSize: 100,
      activeCollapse: 0,
    };
  },
  created() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/opportunity";
    });
    this.detail = stepMenuList[index];
    this.active = index;
    this.lang = localStorage.getItem("language");
    if (!this.$route.query.id) {
      if (this.lang === "cn") {
        this.$message.error("未能找到此条商机！");
      } else {
        this.$message.error("This business opportunity could not be found！");
      }
      this.$router.push({
        path: "/opportunity",
      });
      return false;
    } else {
      this.opportunity_id = this.$route.query.id;
      this.getResponseList();
    }
  },
  methods: {
    async getResponseList() {
      let data = {
        publish_id: this.opportunity_id,
        page_no: this.pageNumber,
        page_size: this.pageSize,
      };
      const res = await getBusinessOpportunityResponseList(
        this.$qs.stringify(data)
      );
      if (res.data.code == 1) {
        res.data.data.lists.forEach((item) => {
          item.active = false;
        });
        res.data.data.lists[0].active = true;
        this.responseList = res.data.data.lists;
        this.getResponseDetail(
          this.activeCollapse,
          this.responseList[this.activeCollapse].id
        );
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to retrieve the response content list！");
        }
      }
    },
    async getResponseDetail(index, id) {
      let data = {
        publish_id: this.opportunity_id,
        id,
      };
      const res = await getBusinessOpportunityResponseDetail(
        this.$qs.stringify(data)
      );
      if (res.data.code == 1) {
        let obj = this.responseList[index];
        obj.response_content = res.data.data.response_content;
        this.$set(this.responseList, index, obj);
        console.log(this.responseList);
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to retrieve the response content！");
        }
      }
    },
    handleDeleteResponse(id) {
      let obj = {};
      if (this.lang === "cn") {
        obj.content = "请问您是否确认删除?";
        obj.tips = "删除";
        obj.comfirm = "确定";
        obj.cancel = "取消";
      } else {
        obj.content = "Are you sure you want to delete?";
        obj.tips = "Delete";
        obj.comfirm = "Confirm";
        obj.cancel = "Cancel";
      }
      this.$confirm(obj.content, obj.tips, {
        confirmButtonText: obj.comfirm,
        cancelButtonText: obj.cancel,
        type: "warning",
      }).then(async () => {
        const res = await deleteBusinessOpportunityResponseDetail({
          id,
          publish_id: this.opportunity_id,
        });
        console.log(res);
        if (res.data.code == 1) {
          if (this.lang == "cn") {
            this.$message.success(res.data.msg);
          } else {
            this.$message.success("Successfully delete!");
          }
          this.activeCollapse = 0;
          this.getResponseList();
        } else {
          if (this.lang == "cn") {
            this.$message.error(res.data.msg);
          } else {
            this.$message.error("Failed to delete!");
          }
        }
      });
    },
    handleOpenCollapseItem(index, id) {
      let arr = this.responseList;
      arr.forEach((item) => {
        item.active = false;
      });
      arr[index].active = true;
      this.responseList = arr;
      this.getResponseDetail(index, id);
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.go-back {
  margin-bottom: 20px;
}
.content-main {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 30px 40px 40px;
  border-radius: 10px;
}
.main-collapse {
  width: 100%;
  margin-top: 20px;
  .main-collapse-header {
    height: 60px;
    font-weight: 700;
    background-color: #f3f3f3;
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    div {
      font-size: 18px;
      font-weight: 700;
    }
    i {
      font-weight: 700;
      font-size: 20px;
      cursor: pointer;
      transition: transform 0.3s;
      &.arrow-rotate {
        transform: rotate(90deg);
      }
    }
  }
  .main-collapse-content {
    border: 1px solid transparent;
    padding: 0 20px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    max-height: 0;
    overflow: hidden;
    color: #fff;
    transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      padding-top 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      padding-bottom 0.3s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.3s 0.1s,
      color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    > div:last-child(2),
    .main-collapse-timing {
      width: 80%;
    }
    .main-collapse-timing {
      font-size: 14px;
      color: #aaa;
      margin-bottom: 16px;
    }
    .main-collapse-delete {
      position: absolute;
      right: 60px;
      bottom: 20px;
      width: 104px;
      height: 36px;
      background: #fce8ec;
      border-radius: 52px;
      color: #e62344;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 16px;
      img {
        width: 16px;
        height: 16px;
      }
      div {
        height: 100%;
        width: 50px;
        font-size: 14px;
        line-height: 36px;
        text-align: center;
      }
    }
    &.active {
      max-height: 1000px; // 设置足够大的值，需大于实际最大高度
      padding-top: 20px;
      padding-bottom: 80px;
      border-color: #f3f3f3;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-delay: 0s; // 取消边框延迟
      color: #333;
    }
  }
}
.main-nodata {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 80px;
  font-weight: 600;
  color: #333;
  font-size: 16px;
}
</style>